import React from 'react';

interface FintechLoaderProps {
    size?: number;
    color?: string;
    className?: string;
}

const FintechLoader: React.FC<FintechLoaderProps> = ({
    size = 75,
    color = '#43e97b',
    className = ''
}) => {
    const containerStyles: React.CSSProperties = {
        width: `${size}px`,
        height: `${size}px`,
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
    };

    // Hexagon container for fintech feel
    const hexagonStyles: React.CSSProperties = {
        position: 'absolute',
        width: '90%',
        height: '90%',
        background: `linear-gradient(135deg, ${color}20, #1976d220, ${color}40)`,
        clipPath: 'polygon(30% 0%, 70% 0%, 100% 50%, 70% 100%, 30% 100%, 0% 50%)',
        animation: 'fintech-hex-pulse 3s ease-in-out infinite',
        willChange: 'transform',
    };

    // Outer rotating ring with gradient
    const outerRingStyles: React.CSSProperties = {
        position: 'absolute',
        width: '100%',
        height: '100%',
        background: `conic-gradient(from 0deg, transparent, ${color}, #1976d2, transparent)`,
        borderRadius: '50%',
        animation: 'fintech-spin 2s linear infinite',
        willChange: 'transform',
        mask: `radial-gradient(circle, transparent ${size * 0.42}px, black ${size * 0.46}px)`,
        WebkitMask: `radial-gradient(circle, transparent ${size * 0.42}px, black ${size * 0.46}px)`,
    };

    // Data visualization bars
    const dataBarStyles = (height: string, delay: string): React.CSSProperties => ({
        position: 'absolute',
        width: `${size * 0.03}px`,
        height: height,
        background: `linear-gradient(to top, ${color}, #1976d2)`,
        borderRadius: `${size * 0.015}px`,
        animation: `fintech-data-wave 2s ease-in-out infinite ${delay}`,
        willChange: 'height, opacity',
    });

    // Inner glowing ring
    const innerGlowStyles: React.CSSProperties = {
        position: 'absolute',
        width: '75%',
        height: '75%',
        border: `2px solid transparent`,
        borderRadius: '50%',
        background: `linear-gradient(45deg, ${color}60, transparent, #1976d260) padding-box`,
        animation: 'fintech-glow-pulse 2.5s ease-in-out infinite alternate',
        willChange: 'box-shadow, transform',
    };

    // Digital circuit pattern
    const circuitStyles: React.CSSProperties = {
        position: 'absolute',
        width: '60%',
        height: '60%',
        background: `
            linear-gradient(90deg, ${color}40 50%, transparent 50%),
            linear-gradient(0deg, #1976d240 50%, transparent 50%)
        `,
        backgroundSize: '4px 4px',
        borderRadius: '50%',
        animation: 'fintech-circuit 4s linear infinite',
        opacity: 0.3,
        willChange: 'transform, opacity',
    };

    const centerStyles: React.CSSProperties = {
        position: 'absolute',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 10,
    };

    const textStyles: React.CSSProperties = {
        fontSize: `${Math.max(8, size * 0.08)}px`,
        fontWeight: 700,
        color: '#1976d2',
        fontFamily: "'JetBrains Mono', 'Fira Code', monospace",
        letterSpacing: '1px',
        textShadow: `0 0 10px ${color}80`,
        zIndex: 15,
        textAlign: 'center',
        lineHeight: 1,
        animation: 'fintech-text-glow 2s ease-in-out infinite alternate',
    };

    const subTextStyles: React.CSSProperties = {
        fontSize: `${Math.max(8, size * 0.04)}px`,
        fontWeight: 400,
        color: 'black',
        fontFamily: "'JetBrains Mono', monospace",
        letterSpacing: '0.5px',
        marginTop: '2px',
        opacity: 0.8,
        animation: 'fintech-fade 3s ease-in-out infinite',
    };

    return (
        <div className={className} style={containerStyles}>
            {/* Hexagon background */}
            <div style={hexagonStyles}></div>
            
            {/* Outer gradient ring */}
            <div style={outerRingStyles}></div>
            
            {/* Data visualization bars */}
         
            
            {/* Inner glowing ring */}
            <div style={innerGlowStyles}></div>
            
            {/* Digital circuit pattern */}
            <div style={circuitStyles}></div>
            
            {/* Center content */}
            <div style={centerStyles}>
                <span style={textStyles}>AHL</span>
                <span style={subTextStyles}>Pay</span>
            </div>
        </div>
    );
};

export default FintechLoader;
